$(".logo-slider").slick({
  centerMode: false,
  centerPadding: "00px",
  slidesToShow: 6,
  arrows: true,
  infinite: true,
  dots: false,
  autoplay: true,
  autoplaySpeed: 2500,
  responsive: [
    {
      breakpoint: 1400,
      settings: {
        arrows: true,
        dots: false,
        centerMode: false,
        centerPadding: "0px",
        slidesToShow: 5,
      },
    },
    {
      breakpoint: 1200,
      settings: {
        arrows: true,
        dots: false,
        centerMode: false,
        centerPadding: "0px",
        slidesToShow: 4,
      },
    },
    {
      breakpoint: 990,
      settings: {
        arrows: false,
        dots: false,
        centerMode: false,
        centerPadding: "0px",
        slidesToShow: 3,
      },
    },
    {
      breakpoint: 750,
      settings: {
        arrows: false,
        dots: false,
        centerMode: false,
        centerPadding: "0px",
        slidesToShow: 2,
      },
    }
  ],
});
